// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-header{align-content:stretch;align-items:center;background-color:var(--page-theme-main-color);color:var(--page-theme-text-color);display:grid;grid-template-columns:[navigation-left] 80px [title] 1fr [navigation-right] 80px;grid-template-rows:100%;height:72px}.page-header__back-link{display:block;margin-left:16px}.page-header__navigation-left{grid-column:navigation-left}.page-header__title{grid-column:title;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
